/** @prettier */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import Currency from '@xanadu/ui-shared/components/Currency';
import Button from '@xanadu/ui-shared/components/widgets/Button';
import { roundDownSmallValue } from '@xanadu/ui-shared/utils/numbers';

import IconBonus from '../../../../../../images/bonus/bonus-icon.svg';
import IconAccount from '../../../../../../images/icons/misc/icon-account-2.svg';
import IconDeposit from '../../../../../../images/icons/misc/icon-cashier.svg';
import IconPortfolio from '../../../../../../images/icons/misc/icon-portfolio.svg';

import BonusDisplay from '../../BonusDisplay';

import styles from './WalletVariant2.module.scss';

const WalletVariant2 = ({
  balance,
  balanceLoading,
  bonusAmount,
  bonusFreeFunds,
  freeSpins,
  freeBets,
  showBonusIcon,
  isMobile,
  cashierEnabled,
  loadingNetDeposit,
  depositButtonText,
  depositButtonDisabled,
  onDepositClick,
  exposureLabel = 'Exposure',
  balanceLabel = 'Available',
  t,
}) => {
  const depositButtonClass = classNames({
    [styles.depositButton]: true,
  });

  const bonusIconClass = classNames({
    [styles.bonusToggle]: true,
    '.gtm_cta': true,
  });

  const BonusIconLink = () => (
    <Link className={bonusIconClass} to="/promotions" data-hook="casino-bonus-icon">
      <IconBonus className="bonus-toggle-icon" />
    </Link>
  );

  const depositButton = (
    <Button
      inverted
      className={depositButtonClass}
      sizeType="regular"
      buttonType="primary"
      dataHook="header-deposit"
      onClick={onDepositClick}
      disabled={depositButtonDisabled || loadingNetDeposit}
    >
      <IconDeposit />
      <span>{isMobile ? t('Add') : t(depositButtonText)}</span>
    </Button>
  );

  return (
    <div className={styles.main}>
      <Link to={'/portfolio/positions'} className={styles.balancesContainer}>
        <span className={styles.portfolioLink}>
          <IconPortfolio />
        </span>
        <div className={styles.balances}>
          {!isMobile && showBonusIcon && <BonusIconLink />}
          {cashierEnabled && (
            <BonusDisplay
              bonusAmount={bonusAmount}
              bonusFreeFunds={bonusFreeFunds}
              freeSpins={freeSpins}
              freeBets={freeBets}
              balanceLoading={balanceLoading}
              t={t}
            />
          )}
          <div className={styles.balanceContainer}>
            <div className={styles.balanceTitle}>{t(exposureLabel)}:</div>
            <div className={styles.balanceValue}>
              <Currency value={roundDownSmallValue(balance.exposure)} round="floor" />
            </div>
          </div>
          <div className={styles.balanceContainer}>
            <div className={styles.balanceTitle}>{t(balanceLabel)}:</div>
            <div className={styles.balanceValue}>
              <Currency value={roundDownSmallValue(balance.freeFunds)} round="floor" />
            </div>
          </div>
        </div>
      </Link>
      {cashierEnabled && depositButton}
      <Link to={'/account'} className={styles.accountLink}>
        <IconAccount />
      </Link>
    </div>
  );
};

WalletVariant2.propTypes = {
  balance: PropTypes.object.isRequired,
  balanceLoading: PropTypes.bool.isRequired,
  bonusAmount: PropTypes.number,
  bonusFreeFunds: PropTypes.number,
  freeSpins: PropTypes.string,
  freeBets: PropTypes.object,
  showBonusIcon: PropTypes.bool,
  isMobile: PropTypes.bool.isRequired,
  cashierEnabled: PropTypes.bool,
  loadingNetDeposit: PropTypes.bool,
  depositButtonText: PropTypes.string.isRequired,
  depositButtonDisabled: PropTypes.bool,
  onDepositClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  exposureLabel: PropTypes.string,
  balanceLabel: PropTypes.string,
};

export default WalletVariant2;
